import { NgModule } from '@angular/core';
import { CalendarComponent } from '@app/pcs/shared/components/calendar/calendar.component';
import { CalendarEditComponent } from '@app/pcs/shared/components/calendar/calendar-edit.component';
import { CalendarSelectionDirective } from '@app/pcs/shared/components/calendar/calendar-selection.directive';
import { DaySelectionDirective } from '@app/pcs/shared/components/calendar/day-selection.directive';
import { CalendarLegendComponent } from '@app/pcs/shared/components/calendar/legend/calendar-legend.component';
import { ValidityPeriodFormComponent } from '@app/pcs/shared/components/calendar/validity-period-form.component';
import { SharedModule } from '@app/shared/shared.module';
import { SubPathLayoutModule } from '@dossier/shared/components/sub-path-layout/sub-path-layout.module';

@NgModule({
  declarations: [
    CalendarComponent,
    CalendarLegendComponent,
    CalendarEditComponent,
    ValidityPeriodFormComponent,
    CalendarSelectionDirective,
    DaySelectionDirective
  ],
  imports: [
    SharedModule,
    SubPathLayoutModule
  ],
  exports: [
    CalendarComponent,
    CalendarEditComponent,
    ValidityPeriodFormComponent,
    CalendarSelectionDirective
  ]
})
export class CalendarModule {
}
